import { render, staticRenderFns } from "./detailsSender.vue?vue&type=template&id=57d52b54"
import script from "./detailsSender.vue?vue&type=script&lang=js"
export * from "./detailsSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports